import React, { useState, useEffect, FunctionComponent } from 'react'
import User from '../lib/models/User'
import { LOCAL_STORAGE_PREFIX } from '../config'

const initUser = (key: string) => {
  const item = localStorage.getItem(key)
  return item ? JSON.parse(item) as User : User.createNew()
}

const UserContext = React.createContext<{
  user: User,
  changeName: (newName: string) => void
}>(null!)

const UserContextProvider: FunctionComponent = (props) => {
  const key = `${LOCAL_STORAGE_PREFIX}-user`
  const [user, setUser] = useState<User>(initUser(key))

  useEffect(() => {
    const item = JSON.stringify(user)
    localStorage.setItem(key, item)
  }, [user])

  const changeName = (newName: string) => {
    const updatedUser = {
      ...user,
      name: newName
    }
    setUser(updatedUser)
  }

  return (
    <UserContext.Provider value={{ user, changeName }}>
      {props.children}
    </UserContext.Provider>
  )

}

export {UserContext, UserContextProvider}